module.exports = __webpack_public_path__ + "img/emoji.e0bd803.png";